import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import './PageStyles.css';
import './PackagesPage.css';

const PackagesPage: React.FC = () => {
  const { t } = useTranslation();

  const packages = [
    {
      name: t('packages.ecommerce.name'),
      price: t('packages.ecommerce.price'),
      features: t('packages.ecommerce.detailedFeatures', { returnObjects: true }) as string[],
      cta: t('packages.ecommerce.cta'),
      popular: false
    },
    {
      name: t('packages.starter.name'),
      price: t('packages.starter.price'),
      features: t('packages.starter.detailedFeatures', { returnObjects: true }) as string[],
      cta: t('packages.starter.cta'),
      popular: false
    },
    {
      name: t('packages.professional.name'),
      price: t('packages.professional.price'),
      features: t('packages.professional.detailedFeatures', { returnObjects: true }) as string[],
      cta: t('packages.professional.cta'),
      popular: true,
      popularLabel: t('packages.professional.popular')
    },
    {
      name: t('packages.fenomen.name'),
      price: t('packages.fenomen.price'),
      features: t('packages.fenomen.detailedFeatures', { returnObjects: true }) as string[],
      cta: t('packages.fenomen.cta'),
      popular: false
    },
    {
      name: t('packages.enterprise.name'),
      price: t('packages.enterprise.price'),
      features: t('packages.enterprise.detailedFeatures', { returnObjects: true }) as string[],
      cta: t('packages.enterprise.cta'),
      popular: false,
      isEnterprise: true
    }
  ];

  return (
    <div className="page-wrapper packages-page marble-bg">
      <section className="detailed-packages section">
        <div className="container">
          <div className="detailed-packages-grid">
            {packages.map((pkg, index) => (
              <motion.div 
                key={index}
                className={`detailed-package-card ${pkg.popular ? 'popular' : ''} ${pkg.isEnterprise ? 'enterprise' : ''}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                {pkg.popular && (
                  <div className="popular-badge">{pkg.popularLabel}</div>
                )}
                <div className="detailed-package-header">
                  <h3 className="detailed-package-name">{pkg.name}</h3>
                  <div className="detailed-package-price">
                    <span className="price">{pkg.price}</span>
                    {!pkg.isEnterprise && <span className="period">{t('packages.monthly')}</span>}
                  </div>
                </div>
                <ul className="detailed-package-features">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx}>
                      <FiCheck className="check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <a 
                  href="https://wa.me/905337757181" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`detailed-package-btn ${pkg.popular ? 'btn-primary' : 'btn-secondary'}`}
                >
                  <FaWhatsapp />
                  {pkg.cta}
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PackagesPage;
